import { useState, useEffect, useCallback } from 'react';
import { collection, onSnapshot, addDoc, doc, updateDoc, deleteDoc, writeBatch } from 'firebase/firestore';
import { db } from '../firebase';

export function useCustomers(userId) {
    const [customers, setCustomers] = useState([]);

    useEffect(() => {
        if (!userId) {
            setCustomers([]);
            return;
        }

        const collectionRef = collection(db, 'users', userId, 'customers');
        const unsubscribe = onSnapshot(collectionRef, (snapshot) => {
            const customersData = snapshot.docs.map(doc => {
                const data = doc.data();
                const birthDate = data.birthDate?.toDate ? data.birthDate.toDate() : null;

                return {
                    id: doc.id,
                    ...data,
                    birthDate: birthDate
                };
            });
            setCustomers(customersData.sort((a, b) => a.name.localeCompare(b.name)));
        });
        
        return () => unsubscribe();
    }, [userId]);

    const addCustomer = useCallback(async (customerData) => {
    if (!userId) return;
    try {
        const collectionRef = collection(db, 'users', userId, 'customers');
        const docRef = await addDoc(collectionRef, customerData); // Guardamos a referência
        return docRef; // RETORNAMOS a referência para o componente saber o ID
    } catch (error) {
        console.error("Erro ao adicionar cliente:", error);
        throw error;
    }
}, [userId]);

    const updateCustomer = useCallback(async (customerId, updatedData) => {
        if (!userId) return;
        try {
            const customerRef = doc(db, 'users', userId, 'customers', customerId);
            await updateDoc(customerRef, updatedData);
        } catch (error) {
            console.error("Erro ao atualizar cliente:", error);
            throw error;
        }
    }, [userId]);

    const deleteCustomer = useCallback(async (customerId) => {
        if (!userId) return;
        try {
            const customerRef = doc(db, 'users', userId, 'customers', customerId);
            await deleteDoc(customerRef);
        } catch (error) {
            console.error("Erro ao deletar cliente:", error);
            throw error;
        }
    }, [userId]);

    const deleteMultipleCustomers = useCallback(async (customerIds) => {
        if (!userId || !customerIds || customerIds.length === 0) {
            return;
        }
        
        const batch = writeBatch(db);
        customerIds.forEach(id => {
            const docRef = doc(db, 'users', userId, 'customers', id);
            batch.delete(docRef);
        });

        try {
            await batch.commit();
        } catch (error) {
            console.error("Erro ao deletar clientes em lote:", error);
            throw error;
        }
    }, [userId]);

    return {
        customers,
        addCustomer,
        updateCustomer,
        deleteCustomer,
        deleteMultipleCustomers
    };
}